module.exports = [{
      plugin: require('../../../node_modules/gatsby-plugin-react-helmet-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteURL":"https://deals.gokinetic.com"},
    },{
      plugin: require('../../../node_modules/@leshen/gatsby-theme-leshen/gatsby-browser.js'),
      options: {"plugins":[],"analyticsId":"GTM-P4SXTKH2","brandTokens":["WDS","WDSB","TND","WDSS"],"mapiBrandToken":"WDS","siteName":"deals.gokinetic","siteURL":"https://deals.gokinetic.com","alternateName":"deals.gokinetic.com","defaultTitleTemplate":"","defaultPhone":"8339706317","phoneSymbol":"-","defaultPromoCode":"173943","smartyStreetsWebsiteKey":"17515620243222457","addressQualificationCode":"windstream","vwoProjectID":"894940","datasetKeys":["kinetic-aoa"]},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"typekit":{"id":"rmk3sth"}},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"deals.gokinetic","short_name":"deals.gokinetic","start_url":"/","background_color":"#","theme_color":"#","icon":"src/images/favicon.svg","display":"browser","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"83aaacc8a1a949a286d4d5a89981e0dc"},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-segment-js/gatsby-browser.js'),
      options: {"plugins":[],"prodKey":"sONmudbSD3VDDjmYOXPfTLBRVH1jbii7","devKey":"","trackPage":true,"trackPageDelay":50},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
